import Model from './Model'

class Order extends Model {
  static primaryKey = 'orderid'
  static entity = 'order'

  static fields () {
    return {
      orderid: this.attr(null),
      userid: this.attr(null),
      date: this.attr(null),
      total: this.attr(null),
      usd_exchange_rate: this.attr(null),
      usd_total: this.attr(null),
      shipment_records: this.attr(null),
      order_detail_records: this.attr(null),
      giftcert_records: this.attr(null),
      status: this.attr(null),
      subtotal: this.attr(null),
      tax: this.attr(null)
    }
  }
}

export default Order
